export const formatearFecha = (fechaStr) => {
  if (!fechaStr) return '—';
  const fecha = new Date(fechaStr);
  if (isNaN(fecha.getTime())) return fechaStr;
  return fecha.toLocaleDateString('es-AR', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatearMoneda = (monto) => {
  if (monto === undefined || monto === null) return '—';
  return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(monto);
};

export const esStockCritico = (stock, stockCritico) => {
  if (stockCritico === undefined || stockCritico === null) return stock <= 3;
  return stock <= stockCritico;
};